import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcProblemInputComponent } from './fc-problem-input.component';


@NgModule({
  declarations: [
    FcProblemInputComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcProblemInputComponent
  ]
})
export class FcProblemInputModule {}
